import { Chip, ChipOwnProps, useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface IProps {
  label: ReactNode
  bgColor?: string
  color?: string
  fontSize?: string
  size?: ChipOwnProps['size']
  sx?: object
}

export const TextTag = ({ label, bgColor, color, fontSize, size, sx }: IProps) => {
  const theme = useTheme()

  return (
    <Chip
      size={size ?? 'small'}
      // onClick={(e) => {
      //   e.preventDefault()
      //   e.stopPropagation()
      // }}
      label={label}
      sx={{
        fontSize: fontSize ?? '11px',
        backgroundColor: bgColor ? bgColor : theme.palette.secondary.main,
        color: color ?? theme.palette.custom.white,
        ...sx,
      }}
    />
  )
}
